package xyz.malefic.gallery.ui

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import kotlinx.browser.localStorage
import kotlinx.browser.window
import org.jetbrains.compose.web.css.rgba
import xyz.malefic.gallery.COLOR_MODE_KEY

object ThemeManager {
    var isDarkMode by mutableStateOf(localStorage.getItem(COLOR_MODE_KEY) == "DARK")
        private set

    fun toggleTheme() {
        isDarkMode = !isDarkMode
        localStorage.setItem(COLOR_MODE_KEY, if (isDarkMode) "DARK" else "LIGHT")
        window.location.reload()
    }
}

object ThemeColors {
    val background get() = if (ThemeManager.isDarkMode) rgba(18, 18, 18, 1) else rgba(248, 249, 250, 1)
    val surface get() = if (ThemeManager.isDarkMode) rgba(30, 30, 30, 1) else rgba(255, 255, 255, 1)
    val text get() = if (ThemeManager.isDarkMode) rgba(255, 255, 255, 0.87) else rgba(33, 37, 41, 1)
    val textSecondary get() = if (ThemeManager.isDarkMode) rgba(255, 255, 255, 0.6) else rgba(108, 117, 125, 1)
    val border get() = if (ThemeManager.isDarkMode) rgba(255, 255, 255, 0.1) else rgba(0, 0, 0, 0.1)
    val hover get() = if (ThemeManager.isDarkMode) rgba(255, 255, 255, 0.05) else rgba(0, 0, 0, 0.04)
}
